// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1bun4","inner":"Footer_inner__3YMsg","nextIcon":"Footer_nextIcon__Sx9t3","innerLeft":"Footer_innerLeft__5Y7qg"};